import { isSupportedLanguage, DEFAULT_LANGUAGE } from '@common'
import { useRouter } from 'next/router'

export function useLocale() {
  const { locale } = useRouter()
  return isSupportedLanguage(locale) ? locale : DEFAULT_LANGUAGE
}
